import { forwardRef } from 'react';

import { cn } from '@/shared/utils/cn';

export const Input = forwardRef(function Input({ className, ...props }, ref) {
  return (
    <input
      ref={ref}
      className={cn(
        'min-h-11 w-full rounded-lg border bg-[var(--app-surface)] px-4 py-2 text-sm shadow-sm transition placeholder:text-[var(--app-muted)] disabled:cursor-not-allowed disabled:opacity-60',
        'focus:border-brand-500 focus:ring-brand-500/15 focus:ring-4 focus:outline-none',
        'aria-invalid:border-red-500 aria-invalid:ring-red-500/10',
        className,
      )}
      {...props}
    />
  );
});
